export const BaseName = '__puc'

export const Names = {
  HISTORIC: `${BaseName}_historic`
}
